import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'analysis-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  constructor(
    public dialogFinish: MatDialogRef<ModalComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  closeDialog(event?: string): void {
    if (this.data?.content?.type === 'queue') {
      this.navigateHome();
    }
    return  this.dialogFinish.close({finalize: true});
  }

  navigateHome() {
    this.router.navigate(['/']);
  }
}